export default "__VITE_ASSET__DXPhHAYn__"